module.exports = __webpack_public_path__ + "img/cloudview_service-overlay-2.97214df5.jpg";